import { render } from "./setting.vue?vue&type=template&id=5c4b5dd7&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=5c4b5dd7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5c4b5dd7"

export default script